"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgAmenityTouchless = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M648.9 614.8c8 0 13.7 4.9 16 10.7C690 715.4 771.1 784.7 875 806.2c6.9 1 11.4 6.8 12.6 12.7 0 6.8-5.7 11.7-12.6 13.7-102.8 21.5-186.2 91.8-210.1 180.7-2.3 6.8-8 10.7-16 10.7s-13.7-4.9-16-10.7C607.8 925.4 525.6 855 422.8 833.6c-8-2-12.6-6.8-12.6-13.7 0-6.8 5.7-11.7 12.6-13.7 103.9-21.5 185-90.8 210.1-180.7 2.3-6.8 8-10.7 16-10.7M307.4 136.4h.3c7.4.1 13.6 4.4 14.7 11.8 29 141.6 139.7 252.1 280.5 281.1 6.4 2.1 11.8 7.5 11.8 15s-5.4 12.9-11.8 15c-140.8 29-251.5 139.5-280.5 280-2.1 6.4-7.5 11.8-15 11.8s-14-4.3-15-11.8c-29-140.6-139.7-251.1-280.5-280-6.4-2.1-11.8-7.5-11.8-15s5.4-13.9 11.8-15c140.8-29 251.5-139.5 280.5-281.1 2.1-6.4 7.5-11.8 15-11.8M784.2 0c8 0 13.7 4.9 16 10.7 25.1 89.8 106.2 159.2 210.1 180.7 8 1 12.6 6.8 13.7 13.7 0 6.8-5.7 11.7-12.6 13.7l-3.1.7c-101.4 22.2-182.2 92-207.1 179-2.3 6.8-8 10.7-16 10.7s-13.7-4.9-16-10.7c-25-87.9-107.2-158.3-210-179.7-8-2-12.6-6.8-12.6-13.7s5.7-11.7 12.6-13.7c103.9-21.5 185-90.8 209-180.7 2.3-6.8 8-10.7 16-10.7" })));
const ForwardRef = (0, react_1.forwardRef)(SvgAmenityTouchless);
exports.default = ForwardRef;
